import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { AppConfigService } from "src/app/app-config.service";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { LookupMedicalCareResponse } from "../../responses/medical-record/lookup-medical-care-response";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../endpint-builder.service";

@Injectable({
    providedIn: 'root'
  })
  export class LookupMedicalCareService extends CommonService{
  
    constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
      super(configService);
    }

    public getLookupMedicalCare(): Observable<LookupMedicalCareResponse>{
      let uri = `LookupMedicalCare`
  
      return this.httpClient.get<LookupMedicalCareResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiMedicalRecord) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}